import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  list: []
};

const gwaRegisterListSlice = createSlice({
  name: 'gwaRegisterList',
  initialState,
  reducers: {
    updateGwaRegisterList: (state, action) => {
      state.list = action.payload;
    }
  }
});

export const { updateGwaRegisterList } = gwaRegisterListSlice.actions;
export default gwaRegisterListSlice.reducer;
